export default __webpack_public_path__ + "static/6-0a4fecff4935157be65ea3a00f98737f.webp";